import React from 'react';
import './TabStyles.css';
import DocSection from "../../../../components/sinistreSection/docSection";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    annulerStyle: {
        width: '83px',
        height: '36px',
        borderRadius: '5px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        backgroundColor: 'rgba(229, 234, 238, 1)',
        color: 'rgba(128, 128, 143, 1)',
        marginRight: '20px'
    },
    validerStyle: {
        width: '83px',
        height: '36px',
        borderRadius: '5px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        backgroundColor: 'rgba(86, 157, 210, 1)',
        color: 'rgba(255, 255, 255, 1)',
        marginRight: '40px'
    }
}));

const FilesTab = ({ handlePrevious, handleNext,formData }) => {
    const classes = useStyles();

    return (
        <div className="container">
            <DocSection claimNumber={formData?.claimNumber} />
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                <button className={classes.annulerStyle} onClick={handlePrevious}>Précédent</button>
                <button className={classes.validerStyle} onClick={handleNext}>Suivant</button>
            </div>
        </div>
    );
};

export default FilesTab;
